export default __webpack_public_path__ + "static/media/farm_logo.568ca988.svg";